import { render } from "./HomeForm.vue?vue&type=template&id=a37af8ac&scoped=true"
import script from "./HomeForm.vue?vue&type=script&lang=js"
export * from "./HomeForm.vue?vue&type=script&lang=js"

import "./HomeForm.vue?vue&type=style&index=0&id=a37af8ac&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a37af8ac"]])

export default __exports__